import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { getTemplateGrupos } from '@ducks/conectoresTemplatesGrupos';

export default function TableGrupos() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const templateGrupos = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('templateGrupos').toArray());
  const loadingTemplateGrupos = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('loadingTemplateGrupos'));

  const handleSearch = () => {
    dispatch(getTemplateGrupos());
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Grupo',
      dataIndex: 'ds',
      key: 'ds',
      width: '85%',
      ...TableSearch('ds', 'grupo', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '15%',
      render: (text) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/templates/grupo/cadastro/${text}`)} />
          <Icon.Detail action={() => history.push(`/conectores/templates/${text}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={templateGrupos} loading={loadingTemplateGrupos} hidePagination />;
}
